<template>
  <div class="toast-container position-fixed top-0 end-0 p-3">
    <div ref="toastEl" class="toast align-items-center" role="alert" aria-live="assertive" aria-atomic="true"
      :class="toastClass">
      <div class="toast-header">
        <strong class="me-auto">{{ title }}</strong>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
      <div class="toast-body">
        {{ body }}
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "bootstrap";
import { onMounted, onBeforeUnmount, ref, computed, nextTick } from "vue";
import { onToast } from "@/services/toast";

export default {
  name: "ToastHost",
  setup() {
    const toastEl = ref(null);
    const title = ref("");
    const body = ref("");
    const variant = ref("");
    let toastInstance = null;
    let unsubscribe = null;

    const toastClass = computed(() => `text-bg-${variant.value}`);

    const showToast = async (payload) => {
      title.value = payload.title || "";
      body.value = payload.body || "";
      variant.value = payload.variant;
      await nextTick();

      if (!toastInstance && toastEl.value) {
        toastInstance = new Toast(toastEl.value, {
          autohide: true,
          delay: payload.delay || 3000,
        });
      }
      toastInstance?.show();
    };

    onMounted(() => {
      unsubscribe = onToast(showToast);
    });

    onBeforeUnmount(() => {
      unsubscribe?.();
      toastInstance?.dispose();
      toastInstance = null;
    });

    return { toastEl, title, body, toastClass };
  },
};
</script>